import React, { useEffect, useState } from "react";
import { getRevenue } from "../../../../services/apiservices/support";
import Spinner from "../../../../components/ui/spinner";

const RevenueEarned = ({ dateFilter }) => {
  const [revenue, setRevenue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setRevenue(null);
    setLoading(true);
    getRevenue(dateFilter).then((data) => {
      setRevenue(data);
      setLoading(false);
    });
  }, [dateFilter]);

  return (
    <div className="bg-[#232834] p-16 rounded-lg">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-gray-400 text-sm">Earned Revenue</p>
          <p className="text-2xl font-bold">
            {loading ? <Spinner size="sm" /> : `${revenue}`}
          </p>
        </div>
      </div>
    </div>
  );
};
export default RevenueEarned;
